// 佐川CSV → SagawaRow[] への変換

import type { SagawaRow, CsvFileMeta } from "../../types";
import { normalizeName, toIsoDate, toNum } from "../normalize";

const REQUIRED_COLS = [
  "集配日", "担当者コード", "担当者名", "集配形態区分",
  "便種コード", "実績便種名", "実績件数", "実績個数", "単数単価", "請求金額",
];

export function parseSagawa(rows: string[][], fileName: string, sizeBytes: number, encoding: string): { meta: CsvFileMeta; sagawaRows: SagawaRow[] } {
  if (rows.length < 2) throw new Error("佐川CSV: データ行がありません");
  const header = rows[0];
  const idx = new Map<string, number>();
  header.forEach((h, i) => idx.set(h, i));

  for (const c of REQUIRED_COLS) {
    if (!idx.has(c)) throw new Error(`佐川CSV: 必須列「${c}」が見つかりません`);
  }

  const cDate = idx.get("集配日")!;
  const cCode = idx.get("担当者コード")!;
  const cName = idx.get("担当者名")!;
  const cOffice = idx.get("営業店名"); // 任意列（周南特殊計上の判定に使う。無い旧CSVでも動く）
  const cShape = idx.get("集配形態区分")!;
  const cBenCode = idx.get("便種コード")!;
  const cBenName = idx.get("実績便種名")!;
  const cKensu = idx.get("実績件数")!;
  const cQty = idx.get("実績個数")!;
  const cTan = idx.get("単数単価")!;
  const cAmount = idx.get("請求金額")!;

  const out: SagawaRow[] = [];
  let minDate = "";
  let maxDate = "";
  for (let r = 1; r < rows.length; r++) {
    const row = rows[r];
    if (!row || row.every((c) => !c)) continue;
    const date = toIsoDate(row[cDate]);
    if (!date) continue;
    if (!minDate || date < minDate) minDate = date;
    if (!maxDate || date > maxDate) maxDate = date;
    const name = row[cName] || "";
    out.push({
      workDate: date,
      driverCode: row[cCode] || "",
      driverName: name,
      driverNameNormalized: normalizeName(name),
      office: cOffice != null ? (row[cOffice] || "") : "",
      benkindCode: row[cBenCode] || "",
      benkindName: row[cBenName] || "",
      shape: row[cShape] || "",
      countItems: toNum(row[cKensu]),
      countQty: toNum(row[cQty]),
      tan: toNum(row[cTan]),
      amount: toNum(row[cAmount]),
    });
  }

  return {
    meta: {
      fileName,
      carrier: "sagawa",
      encoding,
      sizeBytes,
      rows: out.length,
      uploadedAt: new Date().toISOString(),
      periodStart: minDate || null,
      periodEnd: maxDate || null,
    },
    sagawaRows: out,
  };
}
